import React from 'react';
/* eslint-disable */
export function Copy(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.9997 12.8333H14.4997C13.5792 12.8333 12.833 13.5794 12.833 14.4999V21.9999C12.833 22.9204 13.5792 23.6666 14.4997 23.6666H21.9997C22.9202 23.6666 23.6663 22.9204 23.6663 21.9999V14.4999C23.6663 13.5794 22.9202 12.8333 21.9997 12.8333Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.5 17.8333H8.66667C8.22464 17.8333 7.80072 17.6577 7.48816 17.3452C7.17559 17.0326 7 16.6087 7 16.1667V8.66667C7 8.22464 7.17559 7.80072 7.48816 7.48816C7.80072 7.17559 8.22464 7 8.66667 7H16.1667C16.6087 7 17.0326 7.17559 17.3452 7.48816C17.6577 7.80072 17.8333 8.22464 17.8333 8.66667V9.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
